/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

type CodeStageProps = {
  email: string;
  code: string;
  loading: boolean;
  resent: boolean;
  onCodeChange: (value: string) => void;
  onChangeEmail: () => void;
  onResend: () => void;
};

export const CodeStage = defineComponent<CodeStageProps>({
  name: "AuthCodeStage",
  props: [
    "email",
    "code",
    "loading",
    "resent",
    "onCodeChange",
    "onChangeEmail",
    "onResend",
  ],
  setup(props) {
    const { t } = useLocalization();
    return () => (
      <div class="space-y-4">
        <div class="flex flex-col items-center gap-2 text-center">
          <span class="grid size-12 place-items-center rounded-2xl bg-primary/10 text-primary">
            <span class="material-symbols-outlined text-2xl" aria-hidden="true">
              mark_email_read
            </span>
          </span>
          <p class="text-sm">
            {t("customer.account.code_sent_to")}
          </p>
          <p class="flex items-center gap-2 text-sm font-semibold text-base-content">
            {props.email}
            <button
              type="button"
              class="text-xs font-medium text-primary hover:underline"
              onClick={props.onChangeEmail}
            >
              {t("customer.account.change")}
            </button>
          </p>
        </div>
        <input
          type="text"
          inputmode="numeric"
          maxlength={6}
          placeholder="••••••"
          class="input input-bordered input-lg w-full rounded-xl text-center text-2xl font-bold tracking-[0.5em] focus:input-primary"
          value={props.code}
          onInput={(event: Event) =>
            props.onCodeChange(
              (event.target as HTMLInputElement).value
                .replace(/\D/g, "")
                .slice(0, 6),
            )
          }
        />
        <div class="text-center">
          <button
            type="button"
            class="text-sm font-medium text-primary hover:underline disabled:opacity-50"
            disabled={props.loading}
            onClick={props.onResend}
          >
            {props.resent
              ? t("customer.account.code_resent")
              : t("customer.account.resend")}
          </button>
        </div>
      </div>
    );
  },
});
